class ApiManager {
    static url(url){
        return process.env.REACT_APP_API_URL + url;
    }
}
 
export default ApiManager;